import type { GetRecommendationsQuery } from '@data-access/lib/gql/cart/documents'
import { GetRecommendationsDocument } from '@data-access/lib/gql/cart/documents'
import { useGraphQL } from '@data-access/lib/graphql-query'
import { useUrlState } from '@feat/feat-url-state/use-url-state'
import { formatIsoDate } from '@utils/utils-format'

export function useRecommendations(accommodationId: number) {
  const { urlState } = useUrlState()

  const startDate = urlState.from ? formatIsoDate(urlState.from) : undefined
  const endDate = urlState.to ? formatIsoDate(urlState.to) : undefined

  const { refetch: fetchRecommendations, data: recommendation } = useGraphQL(
    GetRecommendationsDocument,
    {
      input: {
        id: accommodationId,
        count: 1,
        type: 'accommodation',
        startDate,
        endDate,
      },
    },
    { enabled: false, select }
  )

  return {
    fetchRecommendations,
    recommendation,
  }
}

const select = ({ getRecommendations }: GetRecommendationsQuery) => getRecommendations
